/* 数字格式化 */
export const numFormat = (money = 0, toFixed = 2) => {
  const numMoney = Number(money);
  if (Number.isNaN(numMoney)) {
    return Number(0).toFixed(toFixed);
  }
  return numMoney.toFixed(toFixed);
};

export const sleep = (ms = 1000) => new Promise(resolve => setTimeout(resolve, ms));

export const guid = () =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

// 星级文案
export const rateText = num => {
  if (num == 1) {
    return "非常差";
  }
  if (num == 2) {
    return "差";
  }
  if (num == 3) {
    return "一般";
  }
  if (num == 4) {
    return "好";
  }
  return "非常好";
};

export const priceSplit = (price = "") => {
  if (price == "") {
    return ["0", ".00"];
  }
  const arr = String(price).split(".");

  return [arr[0], arr[1] ? `.${arr[1]}` : ".00"];
};

// 是否视频文件
export const isVideo = url => {
  const ext = url.split(".").pop() || "";

  if (/mp4|webm|ogv/.test(ext)) {
    return true;
  }

  return false;
};

export const rem = (designWidth, maxWidth = 750) => {
  const doc = document;
  const win = window;
  const docEl = doc.documentElement;
  const remStyle = document.createElement("style");
  let tid;

  function refreshRem() {
    let { width } = docEl.getBoundingClientRect();
    if (width > maxWidth) {
      width = maxWidth;
    }
    const remTem = (width * 100) / designWidth;
    remStyle.innerHTML = `html{font-size:${remTem}px;}`;
    document.documentElement.style.fontSize = `${remTem}px`;
  }

  if (docEl.firstElementChild) {
    docEl.firstElementChild.appendChild(remStyle);
  } else {
    let wrap = doc.createElement("div");
    wrap.appendChild(remStyle);
    doc.write(wrap.innerHTML);
    wrap = null;
  }

  // 要等 wiewport 设置好后才能执行 refreshRem，不然 refreshRem 会执行2次；
  refreshRem();

  win.addEventListener(
    "resize",
    () => {
      clearTimeout(tid); // 防止执行两次
      tid = setTimeout(refreshRem, 300);
    },
    false
  );

  win.addEventListener(
    "pageshow",
    e => {
      if (e.persisted) {
        // 浏览器后退的时候重新计算
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
      }
    },
    false
  );

  if (doc.readyState === "complete") {
    doc.body.style.fontSize = "16px";
  } else {
    doc.addEventListener(
      "DOMContentLoaded",
      () => {
        console.log(122);
        doc.body.style.fontSize = "16px";
      },
      false
    );
  }
};

export const contactService = () => {
  if (window && window.__wxjs_environment === "miniprogram") {
    wx.miniProgram.navigateTo({
      url: "/pages/launchApp/launchApp?type=kf"
    });
  } else {
    if (isInZnt && isInZnt()) {
      window.location.href =
        "weixin://biz/ww/kefu/https://work.weixin.qq.com/kfid/kfcd200d8c554673e56?schema=1&refkey=AQEATdrLFT1hpvU1Y0ePpt41xFLaFiFPYgIxt03NSPsA3eQDgkqcTd13t7KpwkrT-TrO";
    } else {
      window.open("https://work.weixin.qq.com/kfid/kfcd200d8c554673e56");
    }
  }
};
